import PortalIdParser from 'PortalIdParser';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { routes } from '../constants/routes';
import { canViewParticipantsSelector } from '../slices/google/selectors';
const usePortalNavigate = () => {
  const canViewParticipants = useSelector(canViewParticipantsSelector);
  const history = useHistory();

  // handle case when user goes directly from accounts page
  // it's unknown whether user is able to see participants
  useEffect(() => {
    if (canViewParticipants !== null && history.location.pathname === `/${PortalIdParser.getPortalIdFromPath()}`) {
      history.push(`/${PortalIdParser.getPortalIdFromPath()}${canViewParticipants ? routes.contacts : routes.associations}`);
    }
  }, [canViewParticipants, history]);

  // handle case when user goes from past meeting and not host of the meeting
  useEffect(() => {
    if (canViewParticipants === false && history.location.pathname.includes(routes.contacts)) {
      history.push(`/${PortalIdParser.getPortalIdFromPath()}${routes.associations}`);
    }
  }, [canViewParticipants, history]);
};
export default usePortalNavigate;